class SiblingSwatches extends HTMLElement {
  constructor() {
    super();
    this.context = this.dataset.context || 'card';
    this.swatches = this.querySelectorAll('[data-sibling-swatch]');

    if (this.context === 'card') {
      this.card = this.closest('.product-grid__card') || this.closest('.product-card__content');
      if (!this.card) return;
      this.imageNodes = this.card.querySelectorAll('img.product-media__image, img.card__media, .card-gallery img');
      this.linkNodes = this.card.querySelectorAll('a[href*="/products/"]');
      this.priceNodes = this.card.querySelectorAll('.price, .price-item--regular, .price-item--sale');
      this.titleNodes = this.card.querySelectorAll('[role="heading"], .product-grid-view-zoom-out--details .h4');
      this.variantInputs = this.card.querySelectorAll('input[name="id"]');
      this.productInputs = this.card.querySelectorAll('input[name="product-id"]');
    } else if (this.context === 'pdp') {
      this.pdpLabel = this.querySelector('[data-sibling-label]');
      this.originalLabel = this.pdpLabel?.textContent;
    }
  }

  connectedCallback() {
    this.#bindEvents();
  }

  #bindEvents() {
    for (const swatch of this.swatches) {
      if (this.context === 'card') {
        swatch.addEventListener('click', (e) => this.#handleCardSwatchClick(e, swatch));
      } else if (this.context === 'pdp') {
        swatch.addEventListener('mouseenter', () => this.#handlePdpMouseEnter(swatch));
        swatch.addEventListener('mouseleave', () => this.#handlePdpMouseLeave());
        swatch.addEventListener('click', (e) => this.#handlePdpSwatchClick(e, swatch));
      }
    }
  }

  #handleCardSwatchClick(e, activeSwatch) {
    e.preventDefault();
    e.stopPropagation();

    const newUrl = activeSwatch.dataset.url;
    const newTitle = activeSwatch.dataset.title;
    const newVariantId = activeSwatch.dataset.variantId;
    const newProductId = activeSwatch.dataset.productId;
    const newImgSrc = activeSwatch.dataset.image;
    const newHoverImgSrc = activeSwatch.dataset.hoverImage;
    const newPrice = activeSwatch.dataset.price;

    for (const s of this.swatches) {
      s.classList.remove('is-active');
    }
    activeSwatch.classList.add('is-active');

    if (this.imageNodes?.length > 0 && newImgSrc) {
      this.imageNodes[0].removeAttribute('srcset');
      this.imageNodes[0].src = newImgSrc;
      if (this.imageNodes[0].hasAttribute('data_max_resolution')) {
         this.imageNodes[0].setAttribute('data_max_resolution', newImgSrc);
      }

      if (this.imageNodes.length > 1 && newHoverImgSrc) {
        this.imageNodes[1].removeAttribute('srcset');
        this.imageNodes[1].src = newHoverImgSrc;
        if (this.imageNodes[1].hasAttribute('data_max_resolution')) {
           this.imageNodes[1].setAttribute('data_max_resolution', newHoverImgSrc);
        }
      }
    }

    if (newUrl) {
      for (const link of this.linkNodes) {
        link.href = newUrl;
      }
    }

    if (newPrice) {
      for (const node of this.priceNodes) {
        node.innerHTML = newPrice;
      }
    }

    if (newTitle) {
      for (const node of this.titleNodes) {
        node.textContent = newTitle;
      }
    }

    if (newVariantId) {
      for (const input of this.variantInputs) {
        input.value = newVariantId;
      }
    }

    if (newProductId) {
      for (const input of this.productInputs) {
        input.value = newProductId;
      }
    }
  }

  #handlePdpMouseEnter(swatch) {
    if (this.pdpLabel && swatch.dataset.colorName) {
      this.pdpLabel.textContent = swatch.dataset.colorName;
    }
  }

  #handlePdpMouseLeave() {
    if (this.pdpLabel) {
      this.pdpLabel.textContent = this.originalLabel;
    }
  }

  async #handlePdpSwatchClick(e, swatch) {
    e.preventDefault();
    const url = swatch.getAttribute('href');

    const section = this.closest('.shopify-section');
    if (!section) {
      window.location.href = url;
      return;
    }

    const sectionId = section.id.replace('shopify-section-', '');
    const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;

    const loader = this.querySelector('.sibling-section-loader');
    if (loader) {
      document.body.appendChild(loader);
      loader.hidden = false;
    }

    section.style.opacity = '0.5';
    section.style.pointerEvents = 'none';

    try {
      const response = await fetch(fetchUrl);
      const html = await response.text();

      const newSectionDom = new DOMParser().parseFromString(html, 'text/html');
      const newSection = newSectionDom.querySelector('.shopify-section') || newSectionDom.body.firstElementChild;

      if (newSection) {
        section.innerHTML = newSection.innerHTML;
        window.history.replaceState({}, '', url);
        // const secondRadio = document.querySelector('.variant-picker__form input[type="radio"][data-input-index="0"]');
        // if (secondRadio) {
        //   secondRadio.checked = false;
        //   secondRadio.click();
        // }
      }
    } catch (err) {
      console.error('Section Rendering failed', err);
      window.location.href = url;
    } finally {
      if (loader) loader.remove();
      section.style.opacity = '1';
      section.style.pointerEvents = 'auto';
    }
  }
}

if (!customElements.get('sibling-swatches')) {
  customElements.define('sibling-swatches', SiblingSwatches);
}
